import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
// import { debounce } from '@lhb/func';
import { message } from 'antd';

import { sendCaptcha, simpleSenCode } from '@/common/api/common';
import { V2Confirm } from '../../Others/V2Confirm';
interface IProps {
  form: any;
  className?: string;
  onKeepInfo?: Function;
  isSimple?: boolean;
}
const GetCode: FC<IProps> = ({
  form,
  className,
  onKeepInfo,
  isSimple,
}) => {
  const [lockTime, setLockTime] = useState<number>(0);
  const [timer, setTimer] = useState<any>();
  // 获取验证码
  // const getCode = debounce(async () => {
  const getCode = async () => {
    if (lockTime) return;
    const mobile = form.getFieldValue('mobile');
    const mobileError = form.getFieldError('mobile');
    if (!mobile || mobileError.length) {
      message.error('手机号格式不正确，请确认手机号');
      return;
    }
    let hasInCatch = false;
    const targetFetch = isSimple ? simpleSenCode : sendCaptcha;
    await targetFetch({ mobile }).catch((err) => {
      hasInCatch = true;
      // 未注册账号唤起留资弹窗
      if (err?.response?.data?.errCode === 'DE0519999601') {
        V2Confirm({ onSure: () => onKeepInfo && onKeepInfo(mobile), okText: '免费试用', content: '请先申请试用账号', newStyle: false });
      } else {
        message.error(err?.response?.data?.errMsg);
      }
    });
    // 如果上面进入过catch,后面就没必要进行倒计时了
    if (hasInCatch) return;
    setLockTime(60);
    const lockId = setInterval(() => {
      setLockTime((count) => {
        if (count <= 1) {
          clearInterval(lockId);
        }
        return count - 1;
      });
    }, 1000);
    setTimer(lockId);
  // }, 200);
  };
  /* effects */
  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, [timer]);
  return (
    <span className={cs(styles.getCode, className)} onClick={getCode}>
      {lockTime ? `${lockTime} s后重新获取 ` : '获取验证码'}
    </span>
  );
};

export default GetCode;
